export default __webpack_public_path__ + "static/KV_AD_5177_rgb-37d8f0dfb28d0249e02079086c7e9fe8.jpg";